// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__zfhso","sidebar__buttons":"Sidebar_sidebar__buttons__7F7MA"};